/*
 * Navigation tabs component
 *
 * @param {String} tab Active tab
 * @param {Boolean} disabled Disabled tab
 *
 * @return {Element}
 */
<template>
  <div>
    <ul class="nav nav-tabs setting-nav-tabs" id="tabTitle">
      <template v-for="item in navTabs">
        <li :id="`${item.id}-tab`" :class="activeTab(item.id)" :key="item.id" v-if="disabled && item.id !== 'user-info'" class="disabled">
          <a>
            {{ item.name }}
          </a>
        </li>
        <li :id="`${item.id}-tab`" v-else :class="activeTab(item.id)" :key="item.id" @click="changeTab(item.id)">
          <a>
            {{ item.name }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import tabs from '@/common/tabs'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      navTabs: tabs
    }
  },
  props: {
    tab: {
      type: String,
      default: 'user-info'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    },
    /*
     * Change tab
     *
     * @param {String} tabName Tab's name
     *
     * @return void
     */
    changeTab (tabName) {
      let availableTabs = ['user-info', 'login-info', 'plan-info', 'service-info', 'payment-info', 'payment-cycle', 'agent-notice', 'others']
      if (availableTabs.includes(tabName)) {
        let tabsParamsName = {
          user_info: eventCode.settings.user_info_tab.show,
          login_info: eventCode.settings.login_info_tab.show,
          plan_info: eventCode.settings.plan_info_tab.show,
          service_info: eventCode.settings.service_info_tab.show,
          payment_info: eventCode.settings.payment_info_tab.show,
          payment_cycle: eventCode.settings.payment_cycle_tab.show,
          agent_notice: eventCode.settings.agent_notice_tab.show,
          others: eventCode.settings.other_tab.show
        }
        setTimeout(() => {
          $(`#${tabName}-tab`).addClass('disabled-tab')
        }, 500)

        let tabKey = tabName.replaceAll('-', '_')
        let logParams = {
          name: tabsParamsName[tabKey],
          properties: {}
        }
        EventService.postTrackLog(logParams)

        if (tabName === 'payment-info') {
          let payementInfoSelector = $('#payment-method')
          let expandedQaBlock = payementInfoSelector.hasClass('in')
          if (!expandedQaBlock) {
            payementInfoSelector.attr({
              class: 'panel-collapse collapse in',
              'aria-expanded': true,
              style: ''
            })
            $('.question').attr('aria-expanded', 'true')
          }
        }
      }

      this.$router.push(`/setting/${tabName}`)
    }
  },
  watch: {
    tab () {
      if (this.tab === 'user-info') {
        $('.setting-tab-content').css('max-width', '950px')
        $('.setting-nav-tabs').css('max-width', '950px')
      } else if (this.tab === 'plan-info') {
        $('.setting-tab-content').css('max-width', '1200px')
        $('.setting-nav-tabs').css('max-width', '1200px')
      } else {
        $('.setting-tab-content').css('max-width', '900px')
        $('.setting-nav-tabs').css('max-width', '900px')
      }
    }
  },
  mounted () {
    $(`#${this.tab}`).addClass('disabled-tab')
    if (this.tab === 'user-info') {
      $('.setting-tab-content').css('max-width', '950px')
      $('.setting-nav-tabs').css('max-width', '950px')
    } else if (this.tab === 'plan-info') {
      $('.setting-tab-content').css('max-width', '1200px')
      $('.setting-nav-tabs').css('max-width', '1200px')
    } else {
      $('.setting-tab-content').css('max-width', '900px')
      $('.setting-nav-tabs').css('max-width', '900px')
    }
  }
}
</script>

<style scoped>
.disabled-tab {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/NavTabs.vue